import { render } from "./Editar.vue?vue&type=template&id=c66c262c"
import script from "./Editar.vue?vue&type=script&lang=ts"
export * from "./Editar.vue?vue&type=script&lang=ts"
script.render = render

export default script